import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {StudentsDialogComponent} from '../../settings/forms/students-dialog/students-dialog.component';

@Component({
    selector: 'app-report-details-side-info',
    templateUrl: './report-details-side-info.component.html',
    styleUrls: ['./report-details-side-info.component.scss']
})
export class ReportDetailsSideInfoComponent implements OnInit, AfterViewInit {
    @Input() mode;
    @Input() form;
    tableInfo = [];

    constructor(public dialog: MatDialog) {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
        const allInfo = [];

        for (const info of this.form.acceptedInfo) {
            allInfo.push(info);
        }
        for (const info of this.form.declinedInfo) {
            allInfo.push(info);
        }
        for (const info of this.form.pendingInfo) {
            allInfo.push(info);
        }

        for (const info of allInfo) {
            const model = {
                displayName: `${info.childInfo.firstName} ${info.childInfo.lastName}`,
                className: info.childInfo.className,
                school: info.childInfo.school,
                fatherDisplayName: info.fatherInfo.id ? `${info.fatherInfo.firstName} ${info.fatherInfo.lastName}` : '-',
                motherDisplayName: info.motherInfo.id ? `${info.motherInfo.firstName} ${info.motherInfo.lastName}` : '-',
            };
            this.tableInfo.push(model);
        }
    }

    navigateToStudentList(form: any) {
        this.dialog.open(StudentsDialogComponent, {
            width: '1200px',
            height: '650px',
            data: {
                mode: this.mode,
                unique_id: form.unique_id,
                info: this.tableInfo
            }
        });
    }
}
